/** @format */

import React from "react";
import groupsiteImg from "../assets/groupsite.png";
import energysiteImg from "../assets/energysite.png";
import nurafoundationImg from "../assets/nurafoundation.png";
import cleopatraImg from "../assets/cleopatra-site.png";
import linkerImg from "../assets/linker-site.png";
import datastralImg from "../assets/datastral.png";
import "./portfolio.css";

const Portfolio = () => {
  return (
    <article className="portfolio active">
      <header>
        <h2 className="h2 article-title">Portfolio</h2>
      </header>

      <section className="projects">
        <ul className="project-list">
          <li className="project-item active">
            <figure className="project-img">
              <img
                src={groupsiteImg}
                alt="Highbridge Group Website"
                loading="lazy"
              />
              <p className="project-description">
                A responsive corporate website showcasing Highbridge Group’s
                businesses, services, projects, and brand.
              </p>
            </figure>

            <h3 className="project-title">
              Highbridge Group - Corporate Website
            </h3>

            <a
              href="https://www.highbridgegroup.org/"
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-btn"
            >
              View Live Project
            </a>
          </li>

          <li className="project-item active">
            <figure className="project-img">
              <img
                src={energysiteImg}
                alt="Highbridge Energy Website"
                loading="lazy"
              />
              <p className="project-description">
                A responsive e-commerce platform for purchasing solar and energy
                products from Highbridge Energy.
              </p>
            </figure>

            <h3 className="project-title">
              Highbridge Energy – E-commerce Platform
            </h3>

            <a
              href="https://www.highbridgeenergyltd.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-btn"
            >
              View Live Project
            </a>
          </li>

          <li className="project-item active">
            <figure className="project-img">
              <img
                src={nurafoundationImg}
                alt="Nura Foundation Website"
                loading="lazy"
              />
              <p className="project-description">
                A responsive website presenting Nura Foundation’s mission,
                initiatives, and impact.{" "}
              </p>
            </figure>

            <h3 className="project-title">Nura Foundation - NGO Website</h3>

            <a
              href="https://nura-foundation.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-btn"
            >
              View Live Project
            </a>
          </li>

          <li className="project-item active">
            <figure className="project-img">
              <img
                src={cleopatraImg}
                alt="Cleopatra E-commerce"
                loading="lazy"
              />
              <p className="project-description">
                A modern eCommerce website designed for an intuitive and
                engaging shopping experience.
              </p>
            </figure>

            <h3 className="project-title">Cleopatra - E-commerce Website</h3>

            <a
              href="https://cleopatra-ecommerce.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-btn"
            >
              View Live Project
            </a>
          </li>

          <li className="project-item active">
            <figure className="project-img">
              <img
                src={linkerImg}
                alt="Linker Social Media App"
                loading="lazy"
              />
              <p className="project-description">
                A social platform connecting developers and professionals to
                share information and network.
              </p>
            </figure>

            <h3 className="project-title">Linker - Social Media App</h3>

            <a
              href="https://linker-frontend.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-btn"
            >
              View Live Project
            </a>
          </li>

          <li className="project-item active">
            <figure className="project-img">
              <img src={datastralImg} alt="Datastral CMS" loading="lazy" />{" "}
              <p className="project-description">
                A secure content management system designed for efficient retail
                data management.
              </p>
            </figure>

            <h3 className="project-title">
              Datastral - Content Management for Retail
            </h3>

            <a
              href="https://datastral-template.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio-btn"
            >
              View Live Project
            </a>
          </li>
        </ul>
      </section>
    </article>
  );
};
export default Portfolio;
